module.exports = __webpack_public_path__ + "static/media/grey-round-nil.a165dc9e.svg";